<div class="AmPassengerListPriorityCodeItem-itemList"
  [ngClass]="{ 'AmPassengerListPriorityCodeItem-itemList--focus': passenger.select }">
  <div class="AmPassengerListPriorityCodeItem-itemLeft fs-20px lh-26px fw-regular">
    <span>
      {{ numberList }}
    </span>
    <span>
      {{ (passenger?.select ? truncateTextUi(passenger.displayName) : privatedName(passenger)) }}
    </span>
  </div>
  <div>
    <div class="AmPassengerListPriorityCodeItem-itemRight" *ngIf="passenger.seat">
      <span class="AmPassengerListPriorityCodeItem-level fs-14px lh-20px fw-regular">
        <span *ngIf="typeList == 'standby'">
          {{ passenger.fare | titlecase }}
        </span>
      </span>
      <div class="AmPassengerListPriorityCodeItem-seat AmPassengerListPriorityCodeItem-seat--{{passenger.fare}}">
        <span class="fs-18px lh-22px fw-medium-x">
          {{ passenger.seat }}
        </span>
      </div>
    </div>
    <div class="AmPassengerListPriorityCodeItem-itemRight" *ngIf="!passenger.seat">
      <span>
        -
      </span>
    </div>
  </div>
</div>